import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { AgGrid } from '../../../../components'
import { getDefaultColumnDef, preventDefaultRowClick } from '../../../../utils'

import CustomCellRender from './cell/cell.component'

/**
 * Organization Grid
 */
class OrganizationGrid extends PureComponent {
  /**
   * Constructor
   * @param props
   */
  constructor (props) {
    super(props)
    this.state = {
      columns: [
        { ...getDefaultColumnDef(0), field: 'organization', headerName: 'Organization', minWidth: 360 },
        { ...getDefaultColumnDef(1, 'number'), field: 'count', headerName: 'Custom Contacts', minWidth: 200, maxWidth: 200 }
      ]
    }
  }

  /**
   * Handle AgGrid onGridReady event
   * @param grid
   * @see: {@link: https://github.com/ag-grid/ag-grid/issues/997}
   */
  handleGridReady = (grid) => {
    setTimeout(() => this.agGrid = grid, 0)
  }

  /**
   * Handle AgGrid gridSizeChanged event
   * @param type - event type
   */
  handleGridResize = ({ type }) => {
    if (type === 'gridSizeChanged') {
      setTimeout(() => this.agGrid && this.agGrid.api.sizeColumnsToFit(), 0)
    }
  }

  /**
   * Handle row click event
   * @param item
   */
  handleRowClicked = (item) => {
    const { history } = this.props
    const id = item && item.organization && item.organization._id

    id && history.push(`/custom/security/${id}`)
  }

  /**
   * Renders CustomCell Component
   */
  renderCustomCell = (props) => {
    return (<CustomCellRender {...props} />)
  }

  /**
   * Returns grid columns
   */
  getColumnsDefinition = () => {
    return this.state.columns.map(({ typeOfValue, ...column }, idx) => ({
      ...getDefaultColumnDef(idx, typeOfValue),
      ...column
    }))
  }

  /**
   * Render Organization Grid
   * @return {XML}
   */
  render () {
    const { isGridReady, data, total, filters: { page, limit }, handleFilterChange } = this.props

    return (
      <>
        {isGridReady && (
          <AgGrid
            className='organization-grid'
            domLayout='autoHeight'
            sizeToFit={true}

            // suppress configs
            suppressMovableColumns={true}
            suppressContextMenu={true}

            // columns and data
            defaultColDef={{
              suppressMenu: true,
              sortable: false,
              cellRenderer: 'CustomCellRender'
            }}
            columnDefs={this.getColumnsDefinition()}
            rowData={data}

            // pagination
            pagination={true}
            paginationProps={{
              pageSizeId: 'organization-grid',
              forcePage: page,
              initialPageSize: limit,
              showPageSizeSelection: true,
              total,
              onPageChange: ({ selected }) => handleFilterChange({ page: selected }),
              onPageSizeChange: ({ selected }) => handleFilterChange({ page: 1, limit: selected })
            }}

            // custom components
            frameworkComponents={{
              CustomCellRender: this.renderCustomCell
            }}

            // event listeners
            onGridReady={this.handleGridReady}
            onGridSizeChanged={this.handleGridResize}
            onRowClicked={preventDefaultRowClick(this.handleRowClicked)}
          />
        )}
      </>
    )
  }
}

OrganizationGrid.propTypes = {
  isGridReady: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired,
  filters: PropTypes.shape({
    page: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired
  }),
  handleFilterChange: PropTypes.func.isRequired
}

OrganizationGrid.defaultProps = {
  data: [],
  total: 0
}

export default OrganizationGrid
